import { render, staticRenderFns } from "./acountUnlogin.vue?vue&type=template&id=200b0b9e"
import script from "./acountUnlogin.vue?vue&type=script&lang=js"
export * from "./acountUnlogin.vue?vue&type=script&lang=js"
import style0 from "./acountUnlogin.vue?vue&type=style&index=0&id=200b0b9e&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200b0b9e')) {
      api.createRecord('200b0b9e', component.options)
    } else {
      api.reload('200b0b9e', component.options)
    }
    module.hot.accept("./acountUnlogin.vue?vue&type=template&id=200b0b9e", function () {
      api.rerender('200b0b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/acountUnlogin.vue"
export default component.exports